import { call, put, takeLatest } from "redux-saga/effects";
import { OP } from "../../constant";
import {
  doCreateAccount,
  doFetchAccount,
  doViewAccount,
  doDeactivateAccount,
  doApproveAccount,
  doRejectAccount,
  doActivateAccount,
  doViewAgentAccount,
  doGetWakalaAccountDetails,
} from "../../service/accounts";

import errorMessage from "../../utils/error.json";

// fetch account list
function* fetchAccountTask(action) {
  try {
    yield put({ type: OP.ACCOUNT_LIST_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(doFetchAccount, payload.token);

    if (res.status == 200) {
      yield put({
        type: OP.ACCOUNT_LIST_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.ACCOUNT_LIST_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.ACCOUNT_LIST_FAILURE,
      payload: errMsg,
    });
  }
}

// create account
function* createAccountTask(action) {
  try {
    yield put({ type: OP.CREATE_ACCOUNT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doCreateAccount,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.CREATE_ACCOUNT_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.CREATE_ACCOUNT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.CREATE_ACCOUNT_FAILURE,
      payload: errMsg,
    });
  }
}

// view account
function* viewAccountTask(action) {
  try {
    yield put({ type: OP.VIEW_ACCOUNT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doViewAccount,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.VIEW_ACCOUNT_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.VIEW_ACCOUNT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.VIEW_ACCOUNT_FAILURE,
      payload: errMsg,
    });
  }
}

// deactiavate account
function* activateAccountTask(action) {
  try {
    yield put({ type: OP.ACTIVATE_ACCOUNT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doActivateAccount,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.ACTIVATE_ACCOUNT_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.ACTIVATE_ACCOUNT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.ACTIVATE_ACCOUNT_FAILURE,
      payload: errMsg,
    });
  }
}

// deactiavate account
function* deactivateAccountTask(action) {
  try {
    yield put({ type: OP.DEACTIVATE_ACCOUNT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doDeactivateAccount,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.DEACTIVATE_ACCOUNT_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.DEACTIVATE_ACCOUNT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.DEACTIVATE_ACCOUNT_FAILURE,
      payload: errMsg,
    });
  }
}

// approve Account
function* approveAccountTask(action) {
  try {
    yield put({ type: OP.APPROVE_ACCOUNT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doApproveAccount,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.APPROVE_ACCOUNT_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.APPROVE_ACCOUNT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.APPROVE_ACCOUNT_FAILURE,
      payload: errMsg,
    });
  }
}

// reject Account
function* rejectAccountTask(action) {
  try {
    yield put({ type: OP.REJECT_ACCOUNT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doRejectAccount,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.REJECT_ACCOUNT_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.REJECT_ACCOUNT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.REJECT_ACCOUNT_FAILURE,
      payload: errMsg,
    });
  }
}

// view agent account
function* viewAgentAccountTask(action) {
  try {
    yield put({ type: OP.VIEW_AGENT_ACCOUNT_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doViewAgentAccount,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.VIEW_AGENT_ACCOUNT_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.VIEW_AGENT_ACCOUNT_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.VIEW_AGENT_ACCOUNT_FAILURE,
      payload: errMsg,
    });
  }
}

// get wakala account details
function* getWakalaAccountDetailsTask(action) {
  try {
    yield put({ type: OP.GET_WAKALA_ACCOUNT_DETAILS_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doGetWakalaAccountDetails,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.GET_WAKALA_ACCOUNT_DETAILS_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.GET_WAKALA_ACCOUNT_DETAILS_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.GET_WAKALA_ACCOUNT_DETAILS_FAILURE,
      payload: errMsg,
    });
  }
}

function* accountSaga() {
  yield takeLatest(OP.ACCOUNT_LIST_REQUEST, fetchAccountTask);
  yield takeLatest(OP.CREATE_ACCOUNT_REQUEST, createAccountTask);
  yield takeLatest(OP.VIEW_ACCOUNT_REQUEST, viewAccountTask);
  yield takeLatest(OP.ACTIVATE_ACCOUNT_REQUEST, activateAccountTask);
  yield takeLatest(OP.DEACTIVATE_ACCOUNT_REQUEST, deactivateAccountTask);
  yield takeLatest(OP.APPROVE_ACCOUNT_REQUEST, approveAccountTask);
  yield takeLatest(OP.REJECT_ACCOUNT_REQUEST, rejectAccountTask);
  yield takeLatest(OP.VIEW_AGENT_ACCOUNT_REQUEST, viewAgentAccountTask);
  yield takeLatest(
    OP.GET_WAKALA_ACCOUNT_DETAILS_REQUEST,
    getWakalaAccountDetailsTask,
  );
}

export default accountSaga;
